export const formatPrice = (price) => (
  `$${price.toFixed(2)}`
);


export const baseUrl = 'https://free-run-api.herokuapp.com/';
// export const baseUrl = 'http://localhost:3000/';
